import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,

  Typography,
} from "@material-ui/core";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
};

export const Mensajeinfo = (props) => {
  const { info } = props;

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={props.open}
        onClose={props.close}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>{props.titulo}</DialogTitle>
        <DialogContent
          style={{ overflowY: "auto", maxHeight: "40vh", maxWidth: "100vw" }}
        >
          <Typography>
            {`Finalizado por: ${info?.nombreMedicoFinalizado} `}
          </Typography>
          <Typography>
            {info.fechaFinalizado
              ? `Fecha: ${new Date(info.fechaFinalizado).toLocaleString(
                  "es",
                  optionsfecha
                )}`
              : info.pasadoAError
              ? `Fecha: ${new Date(info.pasadoAError).toLocaleString(
                  "es",
                  optionsfecha
                )}`
              : "Fecha no disponible"}
          </Typography>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};
